import { css } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { SportType } from '@scorenco/core';

export const Ranking = ({ ranking, tournament }) => {
  const windowSize = useMediaQuery('(min-width:460px)');

  if (!ranking) {
    return null;
  }

  return (
    <div
      css={css`
        margin-bottom: 1rem;
      `}
    >
      <div
        css={css`
          display: flex;
          padding: 0.25rem 1rem;
        `}
      >
        <div
          css={css`
            flex: 1;
            font-size: 0.75rem;
          `}
        />
        <div
          css={css`
            margin-left: 0.25rem;
            flex: 0 0 1.5rem;
            text-align: center;
            font-size: 0.75rem;
          `}
        >
          Pts
        </div>
        <div
          css={css`
            margin-left: 0.25rem;
            flex: 0 0 1.5rem;
            text-align: center;
            font-size: 0.75rem;
          `}
        >
          Jo
        </div>
        <div
          css={css`
            margin-left: 0.25rem;
            flex: 0 0 1.5rem;
            text-align: center;
            font-size: 0.75rem;
          `}
        >
          G.
        </div>
        {windowSize &&
          (tournament?.sport_id === SportType.Volley ? (
            <>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                P.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                p.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                c.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                d.
              </div>
            </>
          ) : (
            <>
              {tournament?.sport_id !== SportType.Basket && (
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                    font-size: 0.75rem;
                  `}
                >
                  N.
                </div>
              )}
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                P.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                p.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                c.
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  font-size: 0.75rem;
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                d.
              </div>
            </>
          ))}
      </div>
      {ranking?.map((engagement, idxEngagement) => (
        <div
          key={`${idxEngagement}`}
          css={css`
            display: flex;
            border: 1px solid #e2e8ed;
            background: white;
            padding: 0.5rem 1rem;
            margin-top: -1px;
            font-size: 0.875rem;
          `}
        >
          <div
            css={css`
              flex: 0 0 1.5rem;
              text-align: center;
            `}
          >
            {engagement.ranking?.rank ?? '-'}
          </div>
          <div
            css={css`
              margin-left: 0.25rem;
              flex: 1;
              break-after: anywhere;
            `}
          >
            {engagement.team?.name || engagement.name}
          </div>
          <div
            css={css`
              margin-left: 0.25rem;
              flex: 0 0 1.5rem;
              text-align: center;
              font-weight: bold;
            `}
          >
            {engagement.ranking?.pts ?? '-'}
          </div>
          <div
            css={css`
              margin-left: 0.25rem;
              flex: 0 0 1.5rem;
              text-align: center;
            `}
          >
            {engagement.ranking?.played ?? '-'}
          </div>
          <div
            css={css`
              margin-left: 0.25rem;
              flex: 0 0 1.5rem;
              text-align: center;
            `}
          >
            {engagement.ranking?.win ?? '-'}
          </div>
          {windowSize &&
            (tournament?.sport_id === SportType.Volley ? (
              <>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.lost ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.gf ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.ga ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.gd ?? '-'}
                </div>
              </>
            ) : (
              <>
                {tournament?.sport_id !== SportType.Basket && (
                  <div
                    css={css`
                      margin-left: 0.25rem;
                      flex: 0 0 1.5rem;
                      text-align: center;
                    `}
                  >
                    {engagement.ranking?.even ?? '-'}
                  </div>
                )}
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.lost ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.gf ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.ga ?? '-'}
                </div>
                <div
                  css={css`
                    margin-left: 0.25rem;
                    flex: 0 0 1.5rem;
                    text-align: center;
                  `}
                >
                  {engagement.ranking?.gd ?? '-'}
                </div>
              </>
            ))}
        </div>
      ))}
    </div>
  );
};
